import { cn } from "app/lib/utils";

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: "default" | "contrast";
}

function Skeleton({
  className,
  variant = "default",
  ...props
}: Readonly<SkeletonProps>) {
  return (
    <div
      className={cn(
        "animate-pulse rounded-md",
        variant === "default" && "bg-muted",
        variant === "contrast" &&
          "bg-charcoal-05 border-[1px] border-muted-foreground/30",
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
